import { initSubRoutes } from '../../../../utils/router';

const RoutesModificationAdresseSecondaire = initSubRoutes({
    route: '/adresse-secondaire/:idAdresse',
    subroutes: {},
    nom: 'Modification de votre adresse secondaire',
});

export default RoutesModificationAdresseSecondaire;
